import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
interface Plan {
  name: string;
  discount: string;
  badge?: string;
  blurb: string;
  features: string[];
  featured?: boolean;
}
const PLANS: Plan[] = [{
  name: 'Monthly',
  discount: '10% OFF',
  blurb: 'A dependable monthly reset to keep your home guest-ready.',
  features: ['Full home cleaning', 'Eco-friendly products', 'Dedicated cleaner', 'Flexible scheduling']
}, {
  name: 'Weekly',
  discount: '20% OFF',
  badge: 'Most Popular',
  featured: true,
  blurb: 'Our signature plan for a home that is always immaculate.',
  features: ['Everything in Bi-Weekly', 'Priority booking', 'Consistent same-day team', 'One add-on included', 'Satisfaction guarantee']
}, {
  name: 'Bi-Weekly',
  discount: '15% OFF',
  blurb: 'The perfect rhythm for busy NYC professionals.',
  features: ['Full home cleaning', 'Eco-friendly products', 'Dedicated cleaner', 'Priority scheduling']
}];
export function Pricing() {
  return <section id="pricing" className="w-full bg-white" data-id="element-159" data-mp="4v8ishdbw3cs">
      <div className="mx-auto max-w-7xl px-5 pb-20 pt-14 sm:px-8 sm:py-32" data-id="element-160" data-mp="9ta5dc9yqkt0">
        <div className="mx-auto max-w-2xl text-center" data-id="element-161" data-mp="erv4f8dhayfv">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-162" data-mp="ep8yfd68kqzr">
            Pricing
          </span>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-slate" data-id="element-163" data-mp="3i7sihsergqjh">
            Choose your rhythm, save more
          </h2>
          <p className="mt-4 text-slate-soft" data-id="element-164" data-mp="3n5u16c89ynuf">
            The more consistently we care for your home, the more you save.
          </p>
        </div>

        <div className="mx-auto mt-10 flex max-w-md flex-col gap-6 sm:mt-14 sm:gap-10 lg:max-w-none lg:flex-row lg:items-center lg:gap-6" data-id="element-165" data-mp="2uizf5avt7geu">
          {PLANS.map((plan, i) => <motion.div key={plan.name} initial={{
          opacity: 0,
          y: 28
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.08
        }} className={`relative flex w-full flex-col rounded-3xl p-8 ${plan.featured ? 'bg-slate text-white shadow-2xl shadow-slate/30 lg:z-10 lg:scale-105' : 'bg-white ring-1 ring-slate-100 shadow-[0_2px_24px_rgba(15,23,42,0.05)]'} lg:min-w-0 lg:flex-1`} data-id="element-166" data-mp="2rguzve1otwdq" data-mpi={i}>
              {plan.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-magenta px-4 py-1 text-xs font-semibold uppercase tracking-wide text-white shadow-lg shadow-magenta/30" data-id="element-167" data-mp="2dfsbgun809zn">
                  {plan.badge}
                </span>}

              <div className="flex items-baseline justify-between" data-id="element-168" data-mp="a41llomekma">
                <h3 className={`font-display text-xl font-bold ${plan.featured ? 'text-white' : 'text-slate'}`} data-id="element-169" data-mp="59gna33r9lna">
                  {plan.name}
                </h3>
                <span className={`rounded-full px-3 py-1 text-xs font-bold ${plan.featured ? 'bg-magenta text-white' : 'bg-magenta-soft text-magenta'}`} data-id="element-170" data-mp="3rgonkqztj2cg">
                  {plan.discount}
                </span>
              </div>

              <p className={`mt-3 text-sm leading-relaxed ${plan.featured ? 'text-white/75' : 'text-slate-muted'}`} data-id="element-171" data-mp="nz6hop3lw5eo">
                {plan.blurb}
              </p>

              <ul className="mt-6 space-y-3" data-id="element-172" data-mp="e8by5shqvjwx">
                {plan.features.map(f => <li key={f} className="flex items-start gap-3" data-id="element-173" data-mp="11y6beb5z7ahp">
                    <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${plan.featured ? 'text-sky-brand' : 'text-magenta'}`} strokeWidth={2.5} data-id="element-174" data-mp="16qpkovxmrjgp" />
                    <span className={`text-sm ${plan.featured ? 'text-white/90' : 'text-slate-soft'}`} data-id="element-175" data-mp="3a7e1ca14inu4">
                      {f}
                    </span>
                  </li>)}
              </ul>

              <a href="#quote" className={`group mt-8 inline-flex items-center justify-center gap-2 rounded-full px-6 py-3.5 text-sm font-semibold transition-all ${plan.featured ? 'bg-magenta text-white hover:bg-magenta-dark' : 'bg-slate text-white hover:bg-slate/90'}`} data-id="element-176" data-mp="1sm8r08wptc7">
                Get this plan
                <ArrowRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-177" data-mp="3k5tt8f7z614o" />
              </a>
            </motion.div>)}
        </div>
      </div>
    </section>;
}